export const Colors = {
  accent: '#0EA5E9',
  accentDark: '#0284C7',
  accentLight: '#E0F2FE',
  accentBorder: '#BAE6FD',
  accentBgSoft: '#F0F9FF',
  accentBorderSoft: '#7DD3FC',
  accentTextDark: '#075985',

  darkSlate: '#1F2937',
  slate: '#374151',
  steelGrey: '#4B5563',
  slateGrey: '#6B7280',
  slateMuted: '#9CA3AF',
  slateLight: '#475569',

  ink: '#0B1220',
  inkPanelBg: '#0B1220',
  inkPanelSurface: '#131E30',
  inkPanelBorder: '#24314A',

  avatarPinkBg: '#F9D2E4',
  avatarPinkFg: '#D9629B',
  avatarSandBg: '#F5E6C4',
  avatarSandFg: '#B8912F',

  white: '#FFFFFF',
  black: '#000000',
  border: '#E5E7EB',
  borderStrong: '#D1D5DB',
  surface: '#F3F4F6',
  surfaceSoft: '#F8FAFC',

  overlayDark: 'rgba(0, 0, 0, 0.5)',
  overlayDarker: 'rgba(0, 0, 0, 0.6)',
  overlayLight: 'rgba(255, 255, 255, 0.3)',
  overlayText: '#FFFFFF',
  inkPanelMutedText: '#9AA5B4',
  shadowSoft: 'rgba(0, 0, 0, 0.6)',
  shadowMenu: 'rgba(15, 23, 42, 0.14)',

  amber: '#F59E0B',
  amberBg: '#FFFBEB',
  amberBorder: '#FDE68A',
  amberText: '#92400E',
  amberBgSoft: '#FEF3C7',
  amberSolid: '#FBBF24',

  teal: '#0F766E',
  tealBgSoft: 'rgba(0, 137, 123, 0.08)',

  greenCta: '#0EA574',

  success: '#16A34A',
  successBright: '#22C55E',
  successDark: '#15803D',
  successDarkest: '#166534',
  successText: '#065F46',
  successBg: '#F0FDF4',
  successBgSoft: '#D1FAE5',
  successBorder: '#BBF7D0',
  successBorderSoft: '#A7F3D0',

  info: '#1E40AF',
  infoBg: '#DBEAFE',
  infoBorder: '#BFDBFE',

  purpleText: '#5B21B6',
  purpleBgSoft: '#EDE9FE',
  purpleBorder: '#DDD6FE',

  errorRed: '#EF4444',
  error: '#DC2626',
  errorDark: '#991B1B',
  errorDarkest: '#7F1D1D',
  errorBg: '#FEF2F2',
  errorBorder: '#FECACA',

  disabled: '#94A3B8',

  trustBadgeGoldBg: 'rgba(245, 158, 11, 0.12)',
  trustBadgeGoldFg: '#B45309',
  trustBadgeGoldBorder: 'rgba(245, 158, 11, 0.32)',
  trustBadgePurpleBg: 'rgba(139, 92, 246, 0.12)',
  trustBadgePurpleFg: '#6D28D9',
  trustBadgePurpleBorder: 'rgba(139, 92, 246, 0.32)',
  trustBadgeGreenBg: 'rgba(16, 185, 129, 0.12)',
  trustBadgeGreenFg: '#047857',
  trustBadgeGreenBorder: 'rgba(16, 185, 129, 0.32)',
  trustBadgeBlueBg: 'rgba(14, 165, 233, 0.12)',
  trustBadgeBlueFg: '#0369A1',
  trustBadgeBlueBorder: 'rgba(14, 165, 233, 0.32)',
};

export const Spacing = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  xxl: 32,
};
